import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Space} from 'antd';
import {
  StyledInvoiceSelector,
  StyledInvoiceSelectorBr,
  StyledInvoiceSelectorEmpty,
  StyledInvoiceSelectorEmptyText,
  StyledInvoiceSelectorFormContainer,
  StyledInvoiceSelectorFormContainerButtons,
} from './StyledInvoiceSelector';
import InvoiceRadioSelector from '../InvoiceRadioSelector';
import InvoiceTypeSelector from '../InvoiceTypeSelector';

const InvoiceSelector = ({
  onAddInvoice,
  onInvoiceSelect,
  onSelectNoReceipt,
  invoices = [],
  ...rest
}) => {
  const [t] = useTranslation(['main', 'invoices']);

  const actionButtons = <InvoiceTypeSelector onAdd={onAddInvoice} onEdit={onSelectNoReceipt} />;

  return (
    <StyledInvoiceSelector {...rest}>
      {invoices.length ? (
        <StyledInvoiceSelectorFormContainer>
          <Space size='small' direction='vertical'>
            <span>{t('select')} {t('invoice')}</span>
            <InvoiceRadioSelector
              invoices={invoices}
              onChange={onInvoiceSelect}
            />
            <StyledInvoiceSelectorBr>
              {t('or')}
            </StyledInvoiceSelectorBr>
            <StyledInvoiceSelectorFormContainerButtons>
              {actionButtons}
            </StyledInvoiceSelectorFormContainerButtons>
          </Space>
        </StyledInvoiceSelectorFormContainer>
      ) : (
        <StyledInvoiceSelectorEmpty>
          <StyledInvoiceSelectorEmptyText>
            {t('invoices:noInvoiceFound')}
          </StyledInvoiceSelectorEmptyText>
          {actionButtons}
        </StyledInvoiceSelectorEmpty>
      )}
    </StyledInvoiceSelector>
  );
}

InvoiceSelector.propTypes = {
  onAddInvoice: PropTypes.func,
  onInvoiceSelect: PropTypes.func,
  onSelectNoReceipt: PropTypes.func,
  invoices: PropTypes.array
}

export default InvoiceSelector;
